<template>
  <ul class="requirements">
    <li class="requirements__item">
      <div class="requirement text-sm-right">
        <span class="requirement__option">{{ $t('Language') }}:</span>
        <span class="requirement__value">{{ language }}</span>
      </div>
    </li>
    <li class="requirements__item">
      <div class="requirement text-sm-right">
        <span class="requirement__option">{{ $t('Age') }}:</span>
        <span class="requirement__value">{{ age }}</span>
      </div>
    </li>
    <li class="requirements__item">
      <div class="requirement text-sm-right">
        <span class="requirement__option">{{ $t('Lessons') }}:</span>
        <span class="requirement__value">{{ course.lessonscount }}</span>
      </div>
    </li>
    <li class="requirements__item" v-if="course.duration">
      <div class="requirement text-sm-right">
        <span class="requirement__option">{{ $t('Lesson_duration') }}:</span>
        <span class="requirement__value">{{ course.duration }}</span>
      </div>
    </li>
    <li class="requirements__item" v-if="course.duration_course">
      <div class="requirement text-sm-right">
        <span class="requirement__option">{{ $t('Course_duration') }}:</span>
        <span class="requirement__value">{{ course.duration_course }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
import courseApi from '../../data/CourseApi';

export default {
  name: 'CourseRequirements',

  props: {
    course: Object
  },

  computed: {
    language() {
      if (this.course.idlanguage) {
        return courseApi.getLanguageName(this.course.idlanguage);
      }
      return '-';
    },

    age() {
      if (this.course.ages && this.course.ages.length > 0) {
        let ages = [];
        for (let age of this.course.ages) {
          ages.push(courseApi.getAgeName(age.idage))
        }
        return ages.join(', ');
      }
      return courseApi.getAllAgeNames();
    },
  }
}
</script>

<style>

  @media (max-width: 991.8px) {
    .requirements  {
      margin-right: 15px !important;
      margin-left: 15px !important;
    }
  }

  .requirements {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .requirement__option {
    color: #999;
    margin-right: 5px;
  }
  .requirement__value {
    font-family: 'Manrope Bold', 'Open Sans', sans-serif;
  }
</style>
